<template>
  <div class="calls">
    <div class="call-card">
      <div class="grant-info">
        <div class="main-info-top">
          <router-link
            style="text-decoration: none"
            :to="{ name: 'GrantDetails', params: { grantId: id } }"
            v-bind:target="openDetailsInNewTab ? '_blank' : null"
          >
            <div class="grant-text">
              <div class="title"><span v-html="title"></span></div>
            </div>
          </router-link>
          <span
            v-if="grant.identifier && grant.identifier.length > 0"
            class="organisation-text row"
            >{{ grant.identifier }}</span
          >
        </div>

        <div class="other-details">
          <div class="text-details row">
            <div class="detail-item">
              <span class="detail-tag">Status</span>

              <span class="detail-value">{{ statusNL }}</span>
            </div>

            <div class="detail-item row">
              <span class="detail-tag">
                {{ grant.currentDeadlineHeaderText }}</span
              >
              <span class="detail-value">{{ grant.currentDeadlineText }}</span>
            </div>
          </div>
          <div class="action-icons">
            <i
              class="las la-2x la-save action-icon"
          
              @click="enableSaveScheme(schemeId)"
            >
              <q-tooltip>
                Opslaan
              </q-tooltip></i
            >
            <i
              class="las la-2x la-minus-circle action-icon"
              @click="hideScheme(schemeId)"
            >
              <q-tooltip>
                Verbergen
              </q-tooltip></i
            >
            <i
              class="las la-2x la-share action-icon"
              @click="shareGrant()"
            >
              <q-tooltip>
                Delen
              </q-tooltip></i
            >
          </div>
        </div>

        <div class="bottom-options">
          <div class="radiobutton-section row">
            <SelectButton :id="schemeId" :allSelected="selectedResults" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import store from '../store/index';
import GrantsService from '../services/grants.service';
import SelectButton from '../components/GrantSelectButton.vue';
import SchemeUtils from '../utils/schemes';
import UserService from '../services/userprofile.service';

export default {
  name: 'GrantCard',
  props: {
    title: String,
    introduction: String,
    body: String,
    organization: String,
    id: String,
    grant: Object,
  },
  components: {
    SelectButton,
  },

  setup(props) {
    const schemeId = ref(props.id);
    const isSelected = ref(false);

    onMounted(() => {});

    const toggleDisplayCalls = () => (displayCalls.value = !displayCalls.value);

    const selectedResults = computed({
      get: () => store.state.grantItems.selectedResults,
    });

    const displayCalls = ref(false);

    const enableSaveScheme = (id) => {
      store.commit('grantItems/addSelected', id);
      UserService.getFolders();
      store.commit('user/enableSaveScheme');
    };

    const shareGrant = () => {
      store.commit('grantItems/enableShareGrant', props.grant);
    };

    const hideScheme = async (schemeId) => {
      await GrantsService.hideScheme(schemeId);
      SchemeUtils.searchSchemes();
    };

    const openDetailsInNewTab = computed({
      get: () => store.state.user.openDetailsInNewTab,
    });

    const statusNL = SchemeUtils.translateStatus(props.grant.status);

    return {
      statusNL,
      shareGrant,
      selectedResults,
      toggleDisplayCalls,
      displayCalls,
      schemeId,
      isSelected,
      enableSaveScheme,
      hideScheme,
      openDetailsInNewTab,
    };
  },
};
</script>
